import { DpdProductVariant } from "./dpd-product/dpd-product-variant"

export interface IParcelModelHelper {
  dpdProductVariant: DpdProductVariant[] | undefined
  resolveProductVariant(serviceCode: string): ResolvedProductVariant
}

export class ResolvedProductVariant {
  dpdProductVariant: DpdProductVariant | undefined

  constructor(
    dpdProductVariant: DpdProductVariant | undefined
  ) {
    this.dpdProductVariant = dpdProductVariant
  }
}

export class ParcelModelHelper implements ParcelModelHelper {
  dpdProductVariant: DpdProductVariant[] | undefined

  constructor(
    dpdProductVariant: DpdProductVariant[] | undefined
  ) {
    this.dpdProductVariant = dpdProductVariant
  }

  resolveProductVariant(serviceCode: string): ResolvedProductVariant {
    let dpdProductVariant: DpdProductVariant | undefined
    dpdProductVariant = this.dpdProductVariant!.find(
        (variant: DpdProductVariant) =>
            variant.serviceCode.toString() === serviceCode ||
            (exists(variant.serviceBackCode) &&
                variant.serviceBackCode.toString() === serviceCode )
    )
    return new ResolvedProductVariant(dpdProductVariant)
  }
}
